import React from 'react';
import PropTypes from 'prop-types';
import './loader.css';

const Loader = ({ color, show, text }) => (
  <div className={show ? 'm-loader' : 'm-loader hidden'}>
    <svg
      width='52px'
      height='52px'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 100 100'
      preserveAspectRatio='xMidYMid'
      className='uil-ring-alt'
    >
      <rect x='0' y='0' width='100' height='100' fill='none' className='bk' />
      <circle
        cx='50'
        cy='50'
        r='40'
        stroke='#d0d0d0'
        fill='none'
        strokeWidth='10'
        strokeLinecap='round'
      />
      <circle
        cx='50'
        cy='50'
        r='40'
        stroke={color}
        fill='none'
        strokeWidth='6'
        strokeLinecap='round'
      >
        <animate
          attributeName='stroke-dashoffset'
          dur='2s'
          repeatCount='indefinite'
          from='0'
          to='502'
        />
        <animate
          attributeName='stroke-dasharray'
          dur='2s'
          repeatCount='indefinite'
          values='175.7 75.30000000000001;1 250;175.7 75.30000000000001'
        />
      </circle>
    </svg>
    {text !== '' && <div className='loader-text'>{text}</div>}
  </div>
);

Loader.defaultProps = {
  show: false,
  color: '#555555',
  text: null,
};
Loader.propTypes = {
  color: PropTypes.string,
  show: PropTypes.bool,
  text: PropTypes.string,
};

export default Loader;
